import { Slider } from "../../components/Slider";
import React, { useState } from "react";
import { getClippedText } from "../../utils";
import { Button } from "../../../../components/common/Button";

export const HousingInfo = ({
  housing,
  limitedAccess = false,
  isAuth,
  content,
  priorityContent,
}) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const CLIPPED_TEXT_LENGTH = 10;
  const { clippedText, textLength } = getClippedText(
    housing.description,
    CLIPPED_TEXT_LENGTH,
  );
  const canBeClipped = textLength && textLength > CLIPPED_TEXT_LENGTH;
  const description = isDescriptionExpanded ? housing.description : clippedText;
  const metaItems = [
    housing.address
      ? { label: content?.factLabels?.address || "Локация", value: housing.address }
      : null,
    housing.deadline
      ? { label: content?.factLabels?.deadline || "Сдача", value: housing.deadline }
      : null,
    isAuth && content?.showBuilder !== false && housing.builder
      ? {
          label: content?.factLabels?.builder || "Застройщик",
          value: housing.builder,
        }
      : null,
  ].filter(Boolean);

  return (
    <section
      className="overflow-hidden rounded-[28px] border bg-white"
      style={{
        borderColor: "var(--brand-border, #e7ebf0)",
        background: "var(--brand-surface, #ffffff)",
      }}
    >
      <div className="grid gap-0 xl:grid-cols-[minmax(0,1.25fr)_minmax(340px,0.75fr)]">
        <div
          className="min-w-0 border-b xl:border-b-0 xl:border-r"
          style={{ borderColor: "var(--brand-border, #edf1f5)" }}
        >
          <Slider images={housing?.images} />
        </div>

        {priorityContent ? (
          <div
            className="border-b p-5 sm:p-6 xl:hidden"
            style={{ borderColor: "var(--brand-border, #edf1f5)" }}
          >
            {priorityContent}
          </div>
        ) : null}

        <div className="flex min-h-full flex-col justify-between p-5 sm:p-6 lg:p-8">
          <div>
            <div
              className="text-[12px] font-semibold uppercase tracking-[0.14em]"
              style={{ color: "var(--brand-text-secondary, #7a8699)" }}
            >
              {limitedAccess
                ? content?.limitedHeroKicker || "Объект без доступа"
                : content?.heroKicker || "Карточка объекта"}
            </div>

            <h1
              className="mt-3 max-w-[14ch] text-[34px] font-semibold leading-[0.94] sm:max-w-none sm:text-[44px]"
              style={{ color: "var(--brand-text-primary, #101828)" }}
            >
              {housing.housingName}
            </h1>

            <div className="mt-5 flex flex-wrap gap-3">
              {metaItems.length > 0 ? (
                metaItems.map((item) => (
                  <div
                    key={`${item.label}-${item.value}`}
                    className="min-w-[140px] rounded-[16px] border px-4 py-3"
                    style={{
                      borderColor: "var(--brand-border, #edf1f5)",
                      background: "var(--brand-surface-elevated, transparent)",
                    }}
                  >
                    <div
                      className="text-[11px] font-semibold uppercase tracking-[0.08em]"
                      style={{ color: "var(--brand-text-secondary, #98a2b3)" }}
                    >
                      {item.label}
                    </div>
                    <div
                      className="mt-2 text-[15px] font-medium leading-6"
                      style={{ color: "var(--brand-text-primary, #1f2937)" }}
                    >
                      {item.value}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className="rounded-[18px] border border-dashed px-4 py-3 text-[14px]"
                  style={{
                    borderColor: "var(--brand-border, #d0d5dd)",
                    background: "var(--brand-surface-elevated, rgba(255,255,255,0.7))",
                    color: "var(--brand-text-secondary, #667085)",
                  }}
                >
                  {content?.factsEmptyLabel || "Метаданные по объекту пока не заполнены."}
                </div>
              )}
            </div>

            {!limitedAccess && (
              <div
                className="mt-6 border-t pt-6"
                style={{ borderColor: "var(--brand-border, #edf1f5)" }}
              >
                <div
                  className="text-[12px] font-semibold uppercase tracking-[0.12em]"
                  style={{ color: "var(--brand-text-secondary, #7a8699)" }}
                >
                  {content?.descriptionTitle || "Об объекте"}
                </div>
                <div
                  className="mt-3 whitespace-pre-line text-[15px] leading-7"
                  style={{ color: "var(--brand-text-secondary, #475467)" }}
                >
                  {description || content?.descriptionEmptyLabel || "Описание пока не добавлено."}
                </div>
                {canBeClipped && (
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    text={
                      isDescriptionExpanded
                        ? content?.collapseDescriptionLabel || "Свернуть описание"
                        : content?.expandDescriptionLabel || "Показать полностью"
                    }
                    className="mt-4 rounded-full px-4 py-2 text-[13px] font-semibold"
                    style={{
                      borderColor: "var(--brand-secondary-button-border, #d0d5dd)",
                      background: "var(--brand-secondary-button-background, #ffffff)",
                      color: "var(--brand-secondary-button-text, #344054)",
                    }}
                    onClick={() =>
                      setIsDescriptionExpanded(!isDescriptionExpanded)
                    }
                  />
                )}
              </div>
            )}
          </div>

          {limitedAccess && (
            <div
              className="mt-6 border-t pt-6 text-[14px] leading-6"
              style={{
                borderColor: "var(--brand-border, #f1dddd)",
                color: "var(--brand-text-secondary, #7a4855)",
              }}
            >
              {content?.limitedDescriptionLabel ||
                "Для просмотра подробного описания, цен и материалов нужен вход в систему."}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
